import { render, staticRenderFns } from "./chatWeb.vue?vue&type=template&id=34cf2764&scoped=true&"
import script from "./chatWeb.vue?vue&type=script&lang=js&"
export * from "./chatWeb.vue?vue&type=script&lang=js&"
import style0 from "./chatWeb.vue?vue&type=style&index=0&id=34cf2764&prod&lang=css&"
import style1 from "./chatWeb.vue?vue&type=style&index=1&id=34cf2764&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf2764",
  null
  
)

export default component.exports